import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Form.css";

// Wszystkie requesty idą przez Ingress — bez hardcoded IP
const API_URL = "/api";

function Form({ onLogout }) {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  const [formData, setFormData] = useState({
    track_name: "",
    driver_name: "",
    sprocket: "",
    best_lap_time: "",
    cold_pressure_lf: "",
    cold_pressure_rf: "",
    cold_pressure_lr: "",
    cold_pressure_rr: "",
    hot_pressure_lf: "",
    hot_pressure_rf: "",
    hot_pressure_lr: "",
    hot_pressure_rr: "",
    setup_description: "",
  });

  const handleLogout = () => {
    if (onLogout) onLogout();
    navigate("/login");
  };

  const handleGoToDashboard = () => navigate("/dashboard");
  const handleGoToStock = () => navigate("/magazyn");
  const handleGoToCalculator = () => navigate("/kalkulator");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const parsedData = {
      ...formData,
      best_lap_time: formData.best_lap_time ? parseFloat(formData.best_lap_time) : 0,
      cold_pressure_lf: formData.cold_pressure_lf ? parseFloat(formData.cold_pressure_lf) : 0,
      cold_pressure_rf: formData.cold_pressure_rf ? parseFloat(formData.cold_pressure_rf) : 0,
      cold_pressure_lr: formData.cold_pressure_lr ? parseFloat(formData.cold_pressure_lr) : 0,
      cold_pressure_rr: formData.cold_pressure_rr ? parseFloat(formData.cold_pressure_rr) : 0,
      hot_pressure_lf: formData.hot_pressure_lf ? parseFloat(formData.hot_pressure_lf) : 0,
      hot_pressure_rf: formData.hot_pressure_rf ? parseFloat(formData.hot_pressure_rf) : 0,
      hot_pressure_lr: formData.hot_pressure_lr ? parseFloat(formData.hot_pressure_lr) : 0,
      hot_pressure_rr: formData.hot_pressure_rr ? parseFloat(formData.hot_pressure_rr) : 0,
      setup_description: formData.setup_description || null,
    };

    try {
      const res = await fetch(`${API_URL}/data`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(parsedData),
      });

      if (res.status === 401) {
        handleLogout();
        return;
      }
      if (!res.ok) throw new Error("Nie udało się zapisać danych");

      setFormData({
        track_name: "", driver_name: "", sprocket: "", best_lap_time: "",
        cold_pressure_lf: "", cold_pressure_rf: "", cold_pressure_lr: "", cold_pressure_rr: "",
        hot_pressure_lf: "", hot_pressure_rf: "", hot_pressure_lr: "", hot_pressure_rr: "",
        setup_description: "",
      });
      alert("Data saved successfully!");
    } catch (error) {
      console.error("Error:", error);
      alert("Error saving data.");
    }
  };

  return (
    <div className="form-page">
      <div className="form-wrapper">
        {role === "admin" ? (
          <div className="top-buttons">
            <button onClick={handleGoToDashboard} className="admin-button">Dashboard</button>
            <button onClick={handleGoToStock} className="admin-button">Stock</button>
            <button onClick={handleGoToCalculator} className="admin-button">Calculator</button>
            <button onClick={handleLogout} className="logout-button">Log out</button>
          </div>
        ) : (
          <div className="top-buttons">
            <button onClick={handleLogout} className="logout-button">Log out</button>
          </div>
        )}

        <form onSubmit={handleSubmit} className="form-container">
          <h2>GOKART SETUP</h2>

          <div className="general-inputs">
            <div>
              <label>Track name</label>
              <input type="text" name="track_name" value={formData.track_name} onChange={handleChange} required />
            </div>
            <div>
              <label>Driver Name</label>
              <input type="text" name="driver_name" value={formData.driver_name} onChange={handleChange} required />
            </div>
            <div>
              <label>Sprocket</label>
              <input type="text" name="sprocket" value={formData.sprocket} onChange={handleChange} />
            </div>
            <div>
              <label>Best Lap Time</label>
              <input type="text" name="best_lap_time" value={formData.best_lap_time} onChange={handleChange} />
            </div>
          </div>

          <div className="car-visualization">
            <div className="pressure-input front-left">
              <label>Cold Pressure LF</label>
              <input type="text" name="cold_pressure_lf" value={formData.cold_pressure_lf} onChange={handleChange} />
              <label>Hot Pressure LF</label>
              <input type="text" name="hot_pressure_lf" value={formData.hot_pressure_lf} onChange={handleChange} />
            </div>
            <div className="pressure-input front-right">
              <label>Cold Pressure RF</label>
              <input type="text" name="cold_pressure_rf" value={formData.cold_pressure_rf} onChange={handleChange} />
              <label>Hot Pressure RF</label>
              <input type="text" name="hot_pressure_rf" value={formData.hot_pressure_rf} onChange={handleChange} />
            </div>
            <div className="pressure-input rear-left">
              <label>Cold Pressure LR</label>
              <input type="text" name="cold_pressure_lr" value={formData.cold_pressure_lr} onChange={handleChange} />
              <label>Hot Pressure LR</label>
              <input type="text" name="hot_pressure_lr" value={formData.hot_pressure_lr} onChange={handleChange} />
            </div>
            <div className="pressure-input rear-right">
              <label>Cold Pressure RR</label>
              <input type="text" name="cold_pressure_rr" value={formData.cold_pressure_rr} onChange={handleChange} />
              <label>Hot Pressure RR</label>
              <input type="text" name="hot_pressure_rr" value={formData.hot_pressure_rr} onChange={handleChange} />
            </div>
          </div>

          <div className="setup-description">
            <label>Setup Description</label>
            <textarea name="setup_description" value={formData.setup_description} onChange={handleChange} />
            <span className="setup-hint">(/axle/high front-rear/caster-camber kit/front bar/)</span>
          </div>

          <button type="submit">Save</button>
        </form>
      </div>
    </div>
  );
}

export default Form;
